import type { SVGProps } from 'react';

export const MoveLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M18.3333 2.66655H19.6667C20.9553 2.66655 22 3.71122 22 4.99988V18.9999C22 20.2885 20.9553 21.3332 19.6667 21.3332H18.3333C17.0447 21.3332 16 20.2885 16 18.9999V4.99988C16 3.71122 17.0447 2.66655 18.3333 2.66655ZM5.41467 10.9999H13L12.9987 10.9985C13.5507 10.9985 13.9987 11.4465 13.9987 11.9985C13.9987 12.5505 13.5507 12.9985 12.9987 12.9985H5.41334L8.04 15.6252C8.43067 16.0159 8.43067 16.6492 8.04 17.0399C7.84534 17.2359 7.58934 17.3332 7.33334 17.3332C7.07734 17.3332 6.82134 17.2345 6.62667 17.0399L2.29334 12.7065C1.90267 12.3159 1.90267 11.6825 2.29334 11.2919L6.62667 6.95854C7.01734 6.56788 7.65067 6.56788 8.04134 6.95854C8.432 7.34921 8.432 7.98254 8.04134 8.37321L5.41467 10.9999Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
